import React from "react";
import img1 from "../../../Assets/Images/About/ilwall-value-02.png";
import img2 from "../../../Assets/Images/About/ilwall-value-01.png";
import img3 from "../../../Assets/Images/About/ilwall-value-03.png";
import "./style.scss";
import { useTranslation } from "react-i18next";

function Value() {

  const { t } = useTranslation();
  
  return (
    <div className="value">
      <div className="value-info">
        <div className="title">
          <h2>
            ILWall <br />
            {t("value.title")}
          </h2>
        </div>

        <div className="detail">
          <p>
            {t("value.content1")} <br />
            {t("value.content2")}
            <br />
            {t("value.content3")}
            <br />
            {t("value.content4")}
          </p>
        </div>
      </div>

      <div className="value-card">
        <div className="value-card-left">
          {infoCard(
            img1,
            t("value.identity"),
            t("value.identityContent1"),
            t("value.identityContent2") || ""
          )}
        </div>
        <div className="value-card-right">
          <div className="creative">
            {infoCard(
              img2,
              t("value.creative"),
              t("value.creativeContent"),
            )}
          </div>

          <div className="digital">
            {infoCard(
              img3,
              t("value.digital"),
              t("value.digitalContent1"),
              t("value.digitalContent2") || ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Value;

const infoCard = (
  img: any,
  title: string,
  detail: string,
  detail2?: string
) => (
  <>
    <div className="img">
      <img src={img} alt="" />
    </div>
    <div className="info">
      <div className="title">{title}</div>
      <div className="detail">
        {detail} <br />
        {detail2}
      </div>
    </div>
  </>
);
